import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: 0px ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.medium};

  @media (max-width: 640px) {
    gap: ${({ theme }) => theme.spacing.small};
    padding: 0 ${({ theme }) => theme.spacing.small}
      ${({ theme }) => theme.spacing.small};
  }
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const SectionTitle = styled.h4`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`

// Clean table with minimal styling
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-top: none;
  border-radius: ${({ theme }) =>
    `0 0 ${theme.borderRadius.medium} ${theme.borderRadius.medium}`};
  overflow: hidden;

  @media (max-width: 640px) {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`

export const TableHead = styled.thead`
  th {
    padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.medium}`};
    text-align: left;
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.text.tertiary};
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
    background: ${({ theme }) => theme.colors.background.primary};

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      text-align: center;
      width: 150px;
    }

    @media (max-width: 640px) {
      padding: ${({ theme }) =>
        `${theme.spacing.xsmall} ${theme.spacing.small}`};
      font-size: ${({ theme }) => theme.typography.fontSize.micro};

      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        width: 100px;
      }
    }
  }
`

export const TableBody = styled.tbody`
  td {
    padding: ${({ theme }) =>
      `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}`};

    @media (max-width: 640px) {
      padding: ${({ theme }) =>
        `${theme.spacing.xsmall} ${theme.spacing.small}`};
      font-size: ${({ theme }) => theme.typography.fontSize.small};
    }
  }

  tr:hover {
    background: ${({ theme }) => `${theme.colors.background.secondary}20`};
  }
`

export const MetricLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`

export const MetricValueCell = styled.td`
  text-align: center;
  vertical-align: middle;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const EmptyValue = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-style: italic;
  padding-top: ${({ theme }) => theme.spacing.small};
`

export const DifferenceCell = styled.td<{ $isPositive: boolean }>`
  text-align: center;
  vertical-align: middle;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ $isPositive, theme }) =>
    $isPositive ? theme.colors.success : theme.colors.danger};
`

export const AuthorizedValue = styled.div<{
  $isEstimate?: boolean
  $source?: string
  $isUserEdited?: boolean
  $isPending?: boolean
}>`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ $isEstimate, theme }) =>
    $isEstimate ? theme.colors.warning : theme.colors.text.primary};
  cursor: pointer;
  text-decoration: underline dotted;
  text-decoration-color: ${({ theme }) => theme.colors.border.default};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const AuthorizedValueWithBadge = styled.div`
  display: inline-grid;
  justify-items: center;
  grid-template-rows: auto 0;

  /* Badge line overflows below without affecting cell height */
  > :last-child {
    min-height: 16px;
    align-self: start;
  }
`
